module.exports = __webpack_public_path__ + "img/dlw-logo-sendout.1dbdc475.svg";